export default {
  tag: 'Test',
  tag_tooltip: 'Testrestaurant: fuldt funktionsdygtig, faktureres aldrig.',
  card: {
    title: 'Testrestaurant',
    description:
      'Marker én restaurant som din testrestaurant for at afprøve print, e-mails, ordrer og integrationer i produktion. Den fungerer som enhver anden restaurant og faktureres aldrig. Kunde-e-mails og SMS om dens ordrer starter med [TEST].',
    payments_note:
      'Betalinger i testrestauranten er rigtige og udbetales som enhver anden. Refunder testordrer selv. Vi bliver underrettet, når dens månedlige salg vokser ud over test.',
    designated_on: 'Markeret som test den {{date}}',
    open_shop: 'Åbn butik',
    remove: 'Fjern test-markering',
    select_placeholder: 'Vælg en restaurant',
    mark: 'Markér som testrestaurant',
    no_restaurants: 'Du har endnu ingen restaurant at markere.',
    load_error: 'Din testrestaurant kunne ikke indlæses.',
  },
  remove_confirm: {
    title: 'Fjern test-markeringen fra {{name}}?',
    description_live:
      'Fakturering for denne restaurant genoptages, og den går offline med det samme. Genstart den fra Ordreindstillinger → Bestillingsmetoder → Live-bestillinger, hvor du vælger dens plan.',
    description_stays_live: 'Denne restaurant forbliver aktiv og behandles igen som dine andre restauranter fra nu af.',
    description_offline:
      'Fakturering for denne restaurant genoptages, når den går live. Dens plan vælges, når du lancerer den.',
    confirm: 'Fjern test-markering',
  },
  toasts: {
    designated: '{{name}} er nu din testrestaurant. Den faktureres ikke.',
    designate_error: 'Restauranten kunne ikke markeres som test. Prøv igen.',
    removed: '{{name}} er ikke længere din testrestaurant.',
    removed_offline: '{{name}} er ikke længere din testrestaurant og er nu offline.',
    remove_error: 'Test-markeringen kunne ikke fjernes. Prøv igen.',
  },
};
